export const state = () => ({
  color : null,
  icon  : null,
  text  : null
});
